import { heroStats, heroIndex } from "@/mocks/home";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative w-full overflow-hidden border-b border-background-200 bg-background-50"
    >
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-0 h-80 w-80 rounded-full bg-primary-100/50 blur-3xl" />

      <div className="relative mx-auto grid max-w-[1180px] grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-12 lg:gap-12 lg:py-20">
        <div className="animate-fade-rise lg:col-span-7">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-book-2-line" />
              资源大全 · 总目录
            </span>
            <span className="text-xs tracking-[0.25em] text-foreground-500">VOL.91</span>
          </div>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.25] tracking-tight text-foreground-950 sm:text-4xl md:text-[44px] md:leading-[1.22]">
            91下载能下什么？
            <br />
            <span className="text-primary-700">一份资源大全的浏览地图</span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            想知道 91下载能下什么？这里把软件、电影、游戏、视频等资源整理成清晰分区，并汇总当前 91下载资源大全的查找路径。按需浏览，先看分区再看索引，就能快速定位目标内容，省去在平台里来回翻找的麻烦。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#categories"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-700"
            >
              <i className="ri-compass-3-line" />
              进入资源分区
            </a>
            <a
              href="#collections"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 text-sm font-medium text-foreground-800 transition hover:border-foreground-900 hover:bg-background-100"
            >
              <i className="ri-stack-line" />
              查看编辑合集
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200 pt-8 sm:grid-cols-4">
            {heroStats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
                  {item.value}
                </dt>
                <dd className="mt-1 text-xs text-foreground-500 md:text-sm">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <aside className="animate-fade-rise lg:col-span-5">
          <div className="overflow-hidden rounded-lg border border-background-300 bg-background-100">
            <div className="relative h-52 w-full sm:h-60">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20flat%20lay%20with%20stacked%20books%20film%20reel%20game%20controller%20and%20smartphone%20on%20warm%20cream%20paper%20soft%20daylight%20muted%20vermilion%20and%20gold%20accents%20minimal%20geometric%20print%20aesthetic&width=800&height=600&seq=cover-91-magazine&orientation=landscape"
                alt="91下载资源大全封面目录示意"
                title="91下载资源大全 封面目录"
                className="h-full w-full object-cover object-top"
              />
              <span className="absolute left-3 top-3 rounded-full bg-foreground-950/80 px-3 py-1 text-[11px] text-background-50">
                本期封面
              </span>
            </div>

            <div className="p-5">
              <div className="flex items-center justify-between">
                <h2 className="font-heading text-lg font-bold text-foreground-950">
                  本期目录 · 索引
                </h2>
                <i className="ri-list-check-2 text-primary-600" />
              </div>
              <p className="mt-1.5 text-xs text-foreground-500">
                按分区收录量排列，点选即可跳转对应区块
              </p>

              <ul className="mt-4 divide-y divide-background-200">
                {heroIndex.map((item) => (
                  <li key={item.name}>
                    <a
                      href="#categories"
                      className="group flex cursor-pointer items-center justify-between py-2.5"
                    >
                      <span className="flex items-center gap-2 text-sm text-foreground-800">
                        <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                        {item.name}
                      </span>
                      <span className="flex items-center gap-1 text-sm text-foreground-600">
                        {item.count}
                        <span className="text-xs text-foreground-400">{item.unit}</span>
                        <i className="ri-arrow-right-s-line text-foreground-400 transition group-hover:translate-x-0.5 group-hover:text-primary-600" />
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}